import actions from './actions';
import mutations from './mutations';

const state = {
  sidebarColor: null,
  sidebarLogo: null
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
